import axios from "axios";
import { toast } from "react-toastify";
import store from "../store";
import { toBePartiallyChecked } from "@testing-library/jest-dom/matchers";
import { logout } from "../store/authSlice";

const token = store?.auth?.token;

const axiosInstance = axios.create({
  // headers: {
  //   Authorization: token ? `Bearer ${token}` : "", // Use the Bearer token if it exists
  // },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // Retrieve the token from local storage
    const token = localStorage.getItem("vendorAuthToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Set the Authorization header
    }
    console.log({ token, configHeaders: config.headers.Authorization });
    return config;
  },
  (error) => {
    // Handle the error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response, // If response is successful, simply return it
  (error) => {
    if (error.response && error.response.status === 401) {
      // Token has expired or is invalid
      console.error("Token expired, logging out...");
      store.dispatch(logout());
      // window.location='/'
      return toast.error("Token expired, please logout");
      // Redirect to login page
      // Or trigger a logout function depending on your setup

      // For example, if using react-router-dom's `useNavigate`:
      // const navigate = useNavigate();
      // navigate('/login'); // Redirects to the login page
    }
    // Reject any other errors
    console.log(error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
